import React from "react";
import values from "../../values";
import Context from "../../context";
import { Components } from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";

const CategoryPriceScreen = () => {
  const { requestCategory, setRequestCategory, resultCategory } =
    React.useContext(Context.CategoryPriceScreen);

  const { userInfo } = React.useContext(Context.AppContext);

  const categoryPrice = userInfo?.data?.result?.companyPrice;

  console.log(categoryPrice);

  return (
    <CustomView.Container id="driver-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {/* <Components.Create /> */}

          {/* <Components.Filter /> */}
          {/* <Components.Search /> */}
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        {requestCategory?.status === "loading" ? (
          <TableLoading />
        ) : (
          <Components.Body data={categoryPrice} />
        )}
      </div>
      {resultCategory?.status === "success" &&
        resultCategory?.data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestCategory?.page}
              totalPages={resultCategory?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestCategory!({ ...requestCategory, page })
              }
            />
          </div>
        )}
      <Components.UpdatePrice />
    </CustomView.Container>
  );
};

export default CategoryPriceScreen;
